import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./UserDetails.scss";
import edit from "../../assets/images/Icon awesome-edit.png";
import back from "../../assets/images/icons8-arrow-left-66.png";
import plus from "../../assets/images/Icon feather-plus.png";
import ImageInput from "./ImageInput";
import { connection } from "utils/apiConnection.ts";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import defaultUserProfile from "../../assets/images/icons8-user-96.png";
import logout from "../../assets/images/icons8-logout-24.png";
import { toJalaali } from "jalaali-js";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

const UserDetails = ({ user, setUser, setLoader }) => {
  var date = new Date(user.birthdayts * 1000);
  const [editUser, setEditUser] = useState(false);
  const [userE, setUserE] = useState(user);
  const auth = useContext(WithAuthentication);
  const onClickHandlerEdit = () => {
    setEditUser(!editUser);
  };
  const onClickHandlerSubmit = async () => {
    let regex = /^\d{10}$/;
    if (userE.codeMeli.trim() != "" && !regex.test(userE.codeMeli)) {
      Swal.fire({
        title: "لطفا کد ملی را به درستی وارد نمایید.",
        icon: "error",
      });
      return;
    }
    let regexEmail = /.+@.+\..+/;
    if (userE.email.trim() != "" && !regexEmail.test(userE.email)) {
      Swal.fire({
        title: "لطفا ایمیل را به درستی وارد کنید",
        icon: "error",
      });
      return;
    }
    setLoader(true);
    let theObject = {
      fullname: userE.name,
      codemelli: userE.codeMeli,
      address: userE.address,
      mobile: userE.phone,
      email: userE.email,
      birthdayts: userE.birthDay,
      coverImg: userE.profile,
      coverImgId: userE.profileId,
    };
    let result = await connection("edituserprofile", {
      userId: user.id,
      ...theObject,
    });
    if (result.status === 1) {
      setUser((user) => ({
        ...user,
        ...theObject,
      }));
      setEditUser(!editUser);
      theAlert(1);
    } else if (result.status === -1 || result.status === 0) {
      theAlert(2);
      onClickHandlerBack();
    }
    setLoader(false);
  };
  const onClickHandlerBack = () => {
    setUserE({
      name: user.fullname,
      codeMeli: user.codemelli,
      address: user.address,
      phone: user.mobile,
      email: user.email,
      birthDay: user.birthdayts,
      profile: user.coverImg,
      profileId: user.coverImgId,
    });
    if (editUser === true) setEditUser(!editUser);
  };
  const inputHandler = (e) => {
    setUserE({ ...userE, [e.target.name]: e.target.value });
  };
  function onChangeHandlerBirth(date) {
    let birthDay = "";
    if (date?.isValid) {
      birthDay = date.unix;
    }
    setUserE((user) => ({ ...user, birthDay }));
  }
  async function fileHandler(e) {
    setLoader(true);
    let keyvalues = {
      "files[]": e.target.files[0],
    };
    let result = await connection("uploadfiles", keyvalues);
    if (result.status == 1) {
      setUserE({
        ...userE,
        profileId: result.result[0].id,
        profile: result.result[0].path,
      });
    } else {
      setUserE({
        ...userE,
        profile: user.coverImg,
        profileId: user.coverImgId,
      });
    }
    setLoader(false);
  }
  function theAlert(type) {
    let my_icon = type === 1 ? "success" : "error";
    Swal.fire({
      icon: my_icon,
      title: `${type === 1 ? "تایید" : "خطا"} `,
      text: `${
        type === 1
          ? "اطلاعات شما با موفقیت ثبت شد"
          : "مشکلی در ثبت اطلاعات به وجود آمده است"
      }`,
    });
  }
  useEffect(() => {
    setUserE({
      name: user.fullname,
      codeMeli: user.codemelli,
      address: user.address,
      phone: user.mobile,
      email: user.email,
      birthDay: user.birthdayts,
      profile: user.coverImg,
      profileId: user.coverImgId,
    });
  }, [user]);
  const navigate = useNavigate();
  const onClickHandlerLogout = () => {
    auth.logout();
    navigate("../", { replace: true });
  };
  return (
    <div className="Profile">
      <div className="d-lg-flex d-none justify-content-between row">
        <div
          className="logout col-12"
          style={{ textAlign: "left", marginTop: "22px", paddingLeft: "130px" }}
        >
          <img
            src={logout}
            alt="logout"
            onClick={onClickHandlerLogout}
            style={{ transform: "rotate(180deg)", cursor: "pointer" }}
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="خروج"
          />
        </div>
        <div className="d-none d-lg-flex col-1"></div>
        <div className="card col-12 col-lg-3">
          <div>
            <div>
              <label className="items" htmlFor="name">
                نام و نام خانوادگی
              </label>
            </div>
            <div>
              <input
                onChange={inputHandler}
                className="items"
                type="text"
                disabled={editUser ? "" : "disabled"}
                id="name"
                name="name"
                value={userE.name}
              />
            </div>
          </div>
          <hr />
          <div>
            <div>
              <label className="items" htmlFor="codeMeli">
                کد ملی
              </label>
            </div>
            <div>
              <input
                onChange={inputHandler}
                className="items"
                type="text"
                disabled={editUser ? "" : "disabled"}
                id="codeMeli"
                name="codeMeli"
                value={userE.codeMeli}
              />
            </div>
          </div>
          <hr />
          <div>
            <div>
              <label className="items" htmlFor="address">
                آدرس
              </label>
            </div>
            <div>
              {!editUser ? (
                <input
                  onChange={inputHandler}
                  className="items"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="address"
                  name="address"
                  value={userE.address}
                />
              ) : (
                <textarea
                  onChange={inputHandler}
                  className="items"
                  type="text"
                  // disabled={editUser ? "" : "disabled"}
                  id="address"
                  name="address"
                  value={userE.address}
                  rows={3}
                  cols={20}
                />
              )}
            </div>
          </div>
        </div>
        <div className="col-2" style={{ textAlign: "-webkit-center" }}>
          <div className="profile_pic col-12">
            {!editUser ? (
              <>
                {user.coverImg != "" ? (
                  <>
                    <img src={user.coverImg} alt="profile" />
                    <img
                      className="plus"
                      src={plus}
                      alt="plus"
                      style={{ cursor: "pointer" }}
                    />
                  </>
                ) : (
                  <>
                    <img src={defaultUserProfile} alt="profile" />
                    <img
                      className="plus"
                      src={plus}
                      alt="plus"
                      style={{ cursor: "pointer" }}
                    />
                  </>
                )}
              </>
            ) : (
              <ImageInput
                src={userE.profile}
                radiusPercentage={50}
                onChangeHandler={fileHandler}
              />
            )}
          </div>
          <div className="btn edit col-12">
            {editUser ? (
              <>
                <img src={edit} alt="edit" width={15} height={15} />
                <div onClick={onClickHandlerSubmit}> ثبت اطلاعات</div>
              </>
            ) : (
              <>
                <img src={edit} alt="edit" width={15} height={15} />
                <div onClick={onClickHandlerEdit}>ویرایش اطلاعات</div>
              </>
            )}
          </div>
          {editUser ? (
            <div className="btn back col-12" onClick={onClickHandlerBack}>
              <img src={back} alt="back" width={20} height={20} />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="card col-12 col-lg-3">
          <div>
            <div>
              <label className="items" htmlFor="phone">
                شماره تماس
              </label>
            </div>
            <div>
              <input
                onChange={inputHandler}
                className="items"
                type="text"
                disabled="disabled"
                id="phone"
                name="phone"
                value={userE.phone}
              />
            </div>
          </div>
          <hr />
          <div>
            <div>
              <label className="items" htmlFor="email">
                ایمیل
              </label>
            </div>
            <div>
              <input
                onChange={inputHandler}
                className="items"
                type="text"
                disabled={editUser ? "" : "disabled"}
                id="email"
                name="email"
                value={userE.email}
              />
            </div>
          </div>
          <hr />
          <div>
            <div>
              <label className="items" htmlFor="birthDay">
                تاریخ تولد
              </label>
            </div>
            {/* <div>
              <input
                onChange={inputHandler}
                className="items"
                type="text"
                disabled={editUser ? "" : "disabled"}
                id="birthDay"
                name="birthDay"
                value={userE.birthDay}
              />
            </div> */}
            <div style={{ direction: "rtl" }}>
              <DatePicker
                editable={false}
                className="items"
                id="birthDay"
                name="birthDay"
                calendar={persian}
                locale={persian_fa}
                value={userE.birthDay != "" ? userE.birthDay * 1000 : ""}
                maxDate={new Date()}
                onChange={onChangeHandlerBirth}
                calendarPosition="bottom-right"
                readOnly={!editUser}
              />
            </div>
          </div>
        </div>
        <div className="d-none d-lg-flex col-1"></div>
      </div>
      <div
        className="logout col-12 col-sm-11 d-block d-lg-none"
        style={{ textAlign: "left", marginTop: "22px" }}
      >
        <img
          src={logout}
          alt="logout"
          style={{ transform: "rotate(180deg)", cursor: "pointer" }}
          onClick={onClickHandlerLogout}
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="خروج"
        />
      </div>
      <div className="d-lg-none d-flex justify-content-center">
        <div className="col-12 col-sm-10 row justify-content-center">
          <div className="profile_pic col-12">
            {!editUser ? (
              <>
                {user.coverImg != "" ? (
                  <>
                    <img src={user.coverImg} alt="profile" />
                    <img
                      className="plus"
                      src={plus}
                      alt="plus"
                      style={{ cursor: "pointer" }}
                    />
                  </>
                ) : (
                  <>
                    <img src={defaultUserProfile} alt="profile" />
                    <img
                      className="plus"
                      src={plus}
                      alt="plus"
                      style={{ cursor: "pointer" }}
                    />
                  </>
                )}
              </>
            ) : (
              <ImageInput
                src={userE.profile}
                radiusPercentage={50}
                onChangeHandler={fileHandler}
              />
            )}
          </div>
          <div className="card row">
            <div className="col-12 row">
              <div
                className="col-6"
                style={{ borderLeft: "1px solid #DDDBDC" }}
              >
                <label className="items small" type="text" htmlFor="name">
                  نام و نام خانوادگی
                </label>
                <hr />
                <label className="items small" type="text" htmlFor="codeMeli">
                  کد ملی
                </label>
                <hr />
                <label className="items small" type="text" htmlFor="address">
                  آدرس
                </label>
                <hr />
                <label className="items small" type="text" htmlFor="phone">
                  شماره تماس
                </label>
                <hr />
                <label className="items small" type="text" htmlFor="email">
                  ایمیل
                </label>
                <hr />
                <label
                  className="items small"
                  type="text"
                  htmlFor="birthDay"
                  style={{ marginBottom: "20px" }}
                >
                  تاریخ تولد
                </label>
              </div>
              <div className="col-6">
                <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="name"
                  name="name"
                  value={userE.name}
                />
                <hr />
                <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="codeMeli"
                  name="codeMeli"
                  value={userE.codeMeli}
                />
                <hr />
                <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="address"
                  name="address"
                  value={userE.address}
                />
                <hr />
                <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled="disabled"
                  id="phone"
                  name="phone"
                  value={userE.phone}
                />
                <hr />
                <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="email"
                  name="email"
                  value={userE.email}
                />
                <hr />
                {/* <input
                  onChange={inputHandler}
                  className="items small"
                  type="text"
                  disabled={editUser ? "" : "disabled"}
                  id="birthDay"
                  name="birthDay"
                  value={userE.birthDay}
                /> */}
                <DatePicker
                  editable={false}
                  className="items"
                  id="birthDay"
                  name="birthDay"
                  calendar={persian}
                  locale={persian_fa}
                  value={userE.birthDay != "" ? userE.birthDay * 1000 : ""}
                  maxDate={new Date()}
                  onChange={onChangeHandlerBirth}
                  calendarPosition="bottom-right"
                  readOnly={!editUser}
                />
              </div>
            </div>
          </div>
          {editUser ? (
            <div className="btn back col-6" onClick={onClickHandlerBack}>
              <img src={back} alt="back" width={25} height={25} />
            </div>
          ) : (
            ""
          )}
          <div className={`btn edit ${editUser ? "col-6" : ""}`}>
            {editUser ? (
              <>
                <img src={edit} alt="edit" width={20} height={20} />
                <span onClick={onClickHandlerSubmit}> ثبت اطلاعات</span>
              </>
            ) : (
              <>
                <img src={edit} alt="edit" width={20} height={20} />
                <span onClick={onClickHandlerEdit}> ویرایش اطلاعات</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
